(ns quuppa.qsm.projects.events
  (:require [re-frame.core :as rf]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.ui-state.events :as ui-state]
            [quuppa.utils :as utils]))

;;
;; Queries
;;

(def projects-query (q/create-query :qsm/list-projects []))

(rf/reg-event-db :qsm/project-add
  (q/update-event-fn projects-query conj))

(rf/reg-event-db :qsm/project-update
  (q/update-event-fn projects-query (fn [result project]
                                      ;; Replace matching project in a vector
                                      (into (empty result)
                                            (map (fn [v]
                                                   (if (= (:id v) (:id project))
                                                     project
                                                     v))
                                                 result)))))

(rf/reg-event-db :qsm/project-remove
  (q/update-event-fn projects-query (fn [result {:keys [id]}]
                                      ;; Remove matching project from the vector
                                      (into (empty result) (remove #(= id (:id %)) result)))))

;;
;; New project
;;

(rf/reg-event-fx ::init-new-project-form
  (fn [{:keys [db]} _]
    {:db (-> db
             (assoc :project-form {:data {:name        ""
                                          :description ""}
                                   :page :projects})
             (dissoc :site-form))
     :fx [[:dispatch [::ui-state/set-sidebar-type :projects :new-project-form]]]}))

(rf/reg-event-fx ::save-new-project
  (fn [{:keys [db]} _]
    (let [form (:project-form db)]
      {:fx [[:server-dispatch {:event      [:qsm/create-project (:data form)]
                               :on-success [::new-project-created]
                               :on-error   [::save-project-error "Create project failed"]}]]})))

;;
;; Edit project
;;

(rf/reg-event-fx ::init-edit-project-form
  (fn [{:keys [db]} [_ project]]
    {:db (assoc db :project-form {:id   (:id project)
                                  :page :project
                                  :data (select-keys project [:name :description])})
     :fx [[:dispatch [::ui-state/set-sidebar-type :project :project-form]]]}))

(rf/reg-event-fx ::save-project
  (fn [{:keys [db]} _]
    (let [form (:project-form db)]
      {:fx [[:server-dispatch {:event      [:qsm/save-project (assoc (:data form) :project-id (:id form))]
                               :on-success [::save-project-success (:page form)]
                               :on-error   [::save-project-error "Save project failed"]}]]})))

;;
;; New and update project
;;

(rf/reg-event-db ::project-form-set-value
  (fn [db [_ k v]]
    (assoc-in db [:project-form :data k] v)))

(rf/reg-event-db ::select-projects-tab
  (fn [db [_ v]]
    (assoc-in db [:ui-state :projects-selected-tab] v)))

(rf/reg-event-fx ::new-project-created
  (fn [{:keys [db]} [_ new-project]]
    {:db (dissoc db :project-form)
     :fx [[:dispatch [:notifications/notify-success {:message (utils/str-format "Project '%s' created" (:name new-project))}]]
          [:push-state [:project {:project-id (:id new-project)}]]]}))

(rf/reg-event-fx ::cancel-project-form
  (fn [{:keys [db]} _]
    {:db (dissoc db :project-form)
     :fx [(when-let [sidebar-page (get-in db [:project-form :page])]
            [:dispatch [::ui-state/close-sidebar sidebar-page]])]}))

(rf/reg-event-fx ::save-project-success
  (fn [{:keys [db]} [_ page-key]]
    {:db (dissoc db :project-form)
     :fx [[:dispatch [::ui-state/close-sidebar page-key]]]}))

(rf/reg-event-fx ::save-project-error
  (fn [{:keys [db]} [_ message error]]
    {:db (assoc-in db [:project-form :error] {:message message
                                              :data error})}))

;;
;; Delete project
;;

(rf/reg-event-fx ::delete-project
  (fn [_ [_ {project-id :id project-name :name}]]
    {:fx [[:dispatch [:confirm/open {:title "Delete project?"
                                     :message [:span "You are about to delete "
                                               [:strong project-name]
                                               " project. Are you sure?"]
                                     :ok-label "Delete"
                                     :ok-class "btn btn-danger"
                                     :cancel-class "btn btn-outline-secondary"
                                     :on-confirm [::delete-project-confirmed project-id]}]]]}))

(rf/reg-event-fx ::delete-project-confirmed
  (fn [_ [_ project-id]]
    {:fx [[:server-dispatch {:event [:qsm/delete-project {:project-id project-id}]
                             :on-success [::delete-project-done project-id]
                             :on-error [:notifications/notify]}]]}))

(rf/reg-event-fx ::delete-project-done
  (fn [{:keys [db]} [_ project-id _result]]
    ;; If we are on deleted project page, redirect to projects list.
    {:fx [[:dispatch [:confirm/close]]
          (when (and (= :project (-> db :quuppa.routing/match :data :name))
                     (= (str project-id) (-> db :quuppa.routing/match :parameters :path :project-id)))
            [:push-state [:projects]])]}))
